import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "parts/Cards/CounterCards/DefaultCounterCard";

function Counters() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        {/* Grid container with centering adjustments */}
        <Grid
          container
          item
          xs={12}
          lg={9}
          sx={{
            mx: "auto", // Centers the grid horizontally
            display: "flex",
            justifyContent: "center", // Centers items horizontally within the grid
            alignItems: "center", // Centers items vertically
          }}
        >
          {/* First Counter Card */}
          <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
            <DefaultCounterCard
              count={1}
              title="Inventive"
              description="Pioneering Solutions for a Digital Future focuses on using emerging technologies like AI, blockchain, and IoT to drive innovation and solve complex problems. "
            />
          </Grid>

          {/* Divider and Second Counter Card */}
          <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
            <Divider
              orientation="vertical"
              sx={{
                display: { xs: "none", md: "block" },
                mx: 2, // Adds some space between the divider and the content
              }}
            />
            <DefaultCounterCard
              count={2}
              title="Enablement"
              description="Empowering Growth through Innovation emphasizes the role of creative thinking and cutting-edge technology in driving success."
            />
          </Grid>

          {/* Third Counter Card */}
          <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
            <DefaultCounterCard
              count={3}
              title="Responsibility"
              description="Delivering Trustworthy and Ethical Solutions focuses on creating transparent, and responsible technologies that prioritize integrity."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
